import { FC } from 'react';

import styles from './MenuItem.module.css';
import SuccessCheckIcon from '../../atoms/SuccessCheckIcon';
import CheckBox from '../../atoms/CustomCheckBox';

type MenuItemProps = {
  label: string;
  value: string;
  isActive?: boolean;
  onClick: (value: string, isSelected: boolean) => void;
  selectable?: boolean;
  isSelected: boolean;
  isDisabled: boolean;
};

const MenuItem: FC<MenuItemProps> = ({
  label,
  value,
  isActive = false,
  onClick,
  selectable = false,
  isSelected = false,
  isDisabled = false,
}) => {
  const handleClick = () => !isDisabled && onClick(value as string, true);

  const handleKeyDown = () => null;

  return (
    <div
      role='option'
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      aria-selected={isActive}
      tabIndex={-1}
      className={`${styles['menu-item']} ${
        isActive ? styles['menu-item--active'] : ''
      } ${isDisabled ? styles['menu-item--disabled'] : ''}`}
      aria-disabled={isDisabled}
    >
      {selectable && (
        <CheckBox
          isChecked={isSelected}
          isDisabled={isDisabled}
          onChange={() => {}} // Handled by parent onClick
          className={styles['select-option__checkbox']}
        />
      )}
      <div className={styles['menu-item__label']}> {label} </div>
      {!selectable && isSelected && <SuccessCheckIcon />}
    </div>
  );
};

MenuItem.displayName = 'MenuItem';

export default MenuItem;
